import React,{useState,useEffect} from 'react';

const Loader = (props) => {

//    const [show, setShow] = useState(!localStorage.getItem('returning') ? true : false);
    const [show, setShow] = useState(true);

        
    useEffect(() => {
        setTimeout(() => {
            setShow(false)
            // localStorage.setItem('returning',null);
          }, 1300);
        
    },[show]);

    return (
        <div className={`loader-wrapper ${show ? '' : 'loderhide'}`}>
            <div className="typewriter">
                {/* <h1>Loading...</h1> */}
                <div className="loader-box">
                    <div style={{width:"155%"}} className="loader-30"></div>
                  </div>
            </div>
        </div>
    );
}

export default Loader;